module.exports = __webpack_public_path__ + "img/arrow-gray.de0c5504.svg";